import { logger } from '@lessonup/logging-classic';
import { LessonPlan } from '@lessonup/typescript-core/domain';
import { ImageUtils } from '@lessonup/typescript-core/utils';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadPlanAttachment } from './components/DownloadPlanAttachment';
import './css/LessonPlanAttachment.less';

type Props = {
  child: LessonPlan.Children.Attachment;
  planId: string;
};

const LessonPlanAttachment: React.FC<Props> = ({ child, planId }) => {
  const { t } = useTranslation('lessonPlanAttachment');
  const [backgroundImage, setBackgroundImage] = useState<string | undefined>(undefined);
  let attachmentTypeClass = 'type-' + child.attachmentType;

  useEffect(() => {
    if (child.image) {
      const imageUrl = ImageUtils.checkImageUrl(child.image);
      setBackgroundImage(imageUrl);
    }
  }, [child.image]);

  if (!planId) {
    logger.error('PlanId is not defined in a lesson plan attachment');
  }

  if (child.image) {
    attachmentTypeClass += ' has-image';
  }

  const divClasses = 'plan-attachment ' + attachmentTypeClass;

  return (
    <div className="lesson-plan-attachment">
      <div className={divClasses}>
        {backgroundImage ? <div className="visual" style={{ backgroundImage: `url(${backgroundImage})` }}></div> : null}
        <DownloadPlanAttachment planId={planId} child={child}></DownloadPlanAttachment>
        <div className="info">
          <div className="type">{t(child.attachmentType)}</div>
        </div>
      </div>
    </div>
  );
};

export default LessonPlanAttachment;
